import { createEvent, Service } from '@toeverything/infra';
import type { Location } from 'history';
import { distinctUntilChanged, map, skip } from 'rxjs';

import { Workbench } from '../entities/workbench';

export const WorkbenchLocationChanged = createEvent<string>(
  'WorkbenchLocationChanged'
);

export class WorkbenchService extends Service {
  workbench = this.framework.createEntity(Workbench);

  constructor() {
    super();
    this.workbench.location$
      .pipe(
        map((location: Location) => this.workbench.basename$.value + location.pathname),
        distinctUntilChanged(),
        skip(1)
      )
      .subscribe(newLocation => {
        this.eventBus.root.emit(WorkbenchLocationChanged, newLocation);
      });
  }
}
